/**
 * job search teaser block js
 *   handles all interactions with user & jobs api
 *   allows selection of filters & jump to job-search page
 */


import JobsAPI from '../components/JobsAPI';

const filterValues = {
    locations: [],
    categories: [],
    keywords: [],
};

// helpers
const formJobSearch = document.getElementsByClassName('job-search-bar-form')[0];
const selectLocation = formJobSearch.querySelector('#location');
const selectCategory = formJobSearch.querySelector('#category');
const inputKeywords = formJobSearch.querySelector('#keywords');
const inputLocationSearch = formJobSearch.querySelector('#search-locations');
const locationSearchResults = formJobSearch.querySelector('#search-locations-results');

// select load helper
function populateCheckboxes(apiCall, filter1, filter2, checkboxList, currentValues, callback) {
    const list = apiCall(filter1, filter2);
    // console.log('result list', list);

    // clear old options
    checkboxList.innerHTML = '';

    list.forEach((item) => {
        if (item.count) {
            if (currentValues.includes(item.text)) {
                checkboxList.innerHTML += `<label class="checkbox__container">
                    <input
                        type="checkbox"
                        name="${item.text}"
                        title="${item.text}"
                        value="${item.text}"
                        class="js-filter-checkbox"
                        checked/>
                        ${item.text} (${item.count})
                </label>`;
            } else {
                checkboxList.innerHTML += `<label class="checkbox__container">
                    <input
                        type="checkbox"
                        name="${item.text}"
                        title="${item.text}"
                        value="${item.text}"
                        class="js-filter-checkbox"
                        />
                        ${item.text} (${item.count})
                </label>`;
            }
        }
    });

    if (callback) {
        callback();
    }
}

// search button pressed
formJobSearch.addEventListener('submit', (e) => {
    e.preventDefault();

    // ignore submit when focus not on search button
    if (document.activeElement && document.activeElement.classList.contains('js-job-filters-submit')) {
        // handle any strings in json objects
        const jsonData = JSON.stringify(filterValues);

        // encodeURI to handle & in json string data
        const encodedData = encodeURIComponent(jsonData);

        window.location.href = `${e.target.dataset.url}?filterValues=${encodedData}`;
    }

    return false;
});

function initLocationListeners() {
    console.info('initLocationListeners()');
    selectLocation.querySelectorAll('.js-filter-checkbox').forEach((item) => {
        item.addEventListener('change', (e) => {
            if (e.currentTarget.checked) {
                console.log("Checkbox is checked..");
                filterValues.locations.push(e.currentTarget.value);
            } else {
                console.log("Checkbox is not checked..");
                filterValues.locations = filterValues.locations.filter((filterValue) => filterValue !== e.currentTarget.value);
            }

            // filterValues.locations = [...e.currentTarget.selectedOptions].map(option => option.value);

            populateCheckboxes(JobsAPI.getCategorylist, filterValues.locations, filterValues.keywords, selectCategory, filterValues.categories, initCategoryListeners);
        });
    });
};

function initCategoryListeners() {
    console.info('initCategoryListeners()');
    selectCategory.querySelectorAll('.js-filter-checkbox').forEach((item) => {
        item.addEventListener('change', (e) => {
            if (e.currentTarget.checked) {
                console.log("Checkbox is checked..");
                filterValues.categories.push(e.currentTarget.value);
            } else {
                console.log("Checkbox is not checked..");
                filterValues.categories = filterValues.categories.filter((filterValue) => filterValue !== e.currentTarget.value);
            }

            // filterValues.locations = [...e.currentTarget.selectedOptions].map(option => option.value);

            populateCheckboxes(JobsAPI.getLocationList, filterValues.categories, filterValues.keywords, selectLocation, filterValues.locations, initLocationListeners);
        });
    });
}

/*
// NOTE: the popup filtering on mobile has been deactivated.
//  The Search Jobs button now goes direct to the job-search page
const filterToggle = document.getElementsByClassName('js-job-filters-toggle')[0];
const filterBox = document.getElementsByClassName('js-filters-box')[0];
const closeFilters = document.querySelectorAll('.js-close-drawer');
const overlay = document.getElementsByClassName('js-search-overlay')[0];

filterToggle.addEventListener('click', (e) => {
    e.preventDefault();
    filterBox.classList.toggle('active');
    overlay.classList.toggle('active');
});

for (let i = 0; i < closeFilters.length; i+=1) {
    closeFilters[i].addEventListener('click', (e) => {
        e.preventDefault();
        filterBox.classList.remove('active');
        overlay.classList.remove('active');
    });
}

overlay.addEventListener('click', (e) => {
    e.preventDefault();
    filterBox.classList.remove('active');
    overlay.classList.remove('active');
});
 */
document.getElementsByClassName('js-goto-job-search')[0]
    .addEventListener('click', (e) => {
        e.preventDefault();
        window.location.href = `${formJobSearch.dataset.url}`;
        return false;
    });



selectLocation.parentNode.parentNode.querySelector('.js-accordion-toggle').addEventListener('click', (e) => {
    e.currentTarget.parentNode.classList.toggle('active');
});

selectCategory.parentNode.parentNode.querySelector('.js-accordion-toggle').addEventListener('click', (e) => {
    e.currentTarget.parentNode.classList.toggle('active');
});

// handle keyword search
inputKeywords.addEventListener('keyup', (e) => {
    filterValues.keywords = e.currentTarget.value.split(' ');
    populateCheckboxes(JobsAPI.getCategorylist, filterValues.locations, filterValues.keywords, selectCategory, filterValues.categories, initLocationListeners);
    populateCheckboxes(JobsAPI.getLocationList, filterValues.categories, filterValues.keywords, selectLocation, filterValues.locations, initCategoryListeners);
});

// reset button/link
formJobSearch.querySelector('.job-search-block-reset').addEventListener('click', () => {
    filterValues.locations = [];
    filterValues.categories = [];
    filterValues.keywords = [];

    populateCheckboxes(JobsAPI.getLocationList, filterValues.categories, filterValues.keywords, selectLocation, filterValues.locations, initLocationListeners);
    populateCheckboxes(JobsAPI.getCategorylist, filterValues.locations, filterValues.keywords, selectCategory, filterValues.categories, initCategoryListeners);

    formJobSearch.reset();
});

// handle keyword search
inputKeywords.addEventListener('keyup', (e) => {
    filterValues.keywords = e.currentTarget.value.split(' ');
    populateCheckboxes(JobsAPI.getCategorylist, filterValues.locations, filterValues.keywords, selectCategory, filterValues.categories, initCategoryListeners);
    populateCheckboxes(JobsAPI.getLocationList, filterValues.categories, filterValues.keywords, selectLocation, filterValues.locations, initLocationListeners);
});

// locations list search
inputLocationSearch.addEventListener('keyup', (e) => {
    const searchString = e.currentTarget.value.toUpperCase();
    console.log(searchString);

    const results = JobsAPI.getLocationList().filter((obj) => {
        if (obj.text.toUpperCase().indexOf(searchString) === -1) {
            return false;
        }
        return true;
    });

    if (searchString) {
        let html = '<ul>';
        if (results.length) {
            results.forEach((location) => {
                html += `<li class="js-location-result" tabindex="0">${location.text}</li>`
            })
        } else {
            html += '<li>There aren\'t any search results for the location you entered.</li>'
        }

        html += '</ul>';
        locationSearchResults.classList.remove('hidden');

        locationSearchResults.innerHTML = html;
    } else {
        locationSearchResults.classList.add('hidden');
    }
});

// handle escape key
inputLocationSearch.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        inputLocationSearch.value = '';
        locationSearchResults.classList.add('hidden');
    }
});

// handle selecting a location in the results
const locationResultEventHandler = (e) => {
    if (e.target.classList.contains('js-location-result')) {
        locationSearchResults.classList.add('hidden');
        inputLocationSearch.value = e.target.innerHTML;
        filterValues.locations.push(e.target.innerHTML);
        populateCheckboxes(JobsAPI.getLocationList, filterValues.categories, filterValues.keywords, selectLocation, filterValues.locations, initLocationListeners);
        populateCheckboxes(JobsAPI.getCategorylist, filterValues.locations, filterValues.keywords, selectCategory, filterValues.categories, initCategoryListeners);
        inputLocationSearch.value = '';
    }
};
locationSearchResults.addEventListener('click', locationResultEventHandler);
locationSearchResults.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
        locationResultEventHandler(e);
    }
});

JobsAPI.init().then((result) => {
    if (result) {
        // init data handilng
        populateCheckboxes(JobsAPI.getLocationList, filterValues.categories, filterValues.keywords, selectLocation, filterValues.locations, initLocationListeners);
        populateCheckboxes(JobsAPI.getCategorylist, filterValues.locations, filterValues.keywords, selectCategory, filterValues.categories, initCategoryListeners);
    }
});

